<template>
  <PubPage>
    <BasicTable
      :columns="columns"
      bordered
      :dataSource="list"
      :loading="loading"
      boxShadow
      :pagination="{
        current: form.paging.page,
        pageSize: form.paging.limit,
        total: pageTotal,
      }"
      @searchBack="searchBack"
      @pagesChange="pagesChange"
    >
      <template #tableTitle>
        <div class="pub-tableTitle-button">
          <a-button
            type="primary"
            class="btn-green"
            icon="plus-circle"
            @click="add('add')"
            >添加学校</a-button
          >
        </div>
      </template>
      <template slot="index" slot-scope="{ index }">
        {{ index + 1 }}
      </template>
      <template slot="status" slot-scope="{ record }">
        <PubEnableStatus :status="record.status" />
      </template>
      <template slot="city" slot-scope="{ record }">
        {{ record.province }}-{{ record.city }}-{{ record.area }}
      </template>

      <template slot="options" slot-scope="{ record }">
        <div class="pub-options">
          <a @click="dockList(record)" class="blue">
            <a-icon type="compass" />对接平台
          </a>
          <a @click="add('edit', record)"> <a-icon type="form" />编辑 </a>
          <a @click="deleteCustomer(record.id)" class="red">
            <a-icon type="delete" />删除
          </a>
        </div>
      </template>
    </BasicTable>
    <AddModal ref="addModalModal" @ok="moduleOk" />
    <DockingList ref="dockingListModal" />
  </PubPage>
</template>

<script>
import { SettingSchool } from "@/api";
import AddModal from "./AddModal.vue";
import DockingList from "./module/dockingList.vue";
export default {
  components: {
    AddModal,
    DockingList,
  },
  data() {
    const columns = [
      {
        title: "序号",
        dataIndex: "index",
        align: "center",
        width: 50,
        hideInSearch: true,
        scopedSlots: true,
      },
      {
        title: "学校名称",
        dataIndex: "name",
      },
      {
        title: "城市",
        dataIndex: "city",
        align: "left",
        hideInSearch: true,
        scopedSlots: true,
      },
      {
        title: "学校地址",
        dataIndex: "address",
        align: "left",
        hideInSearch: true,
      },
      {
        title: "状态",
        dataIndex: "status",
        align: "center",
        width: 100,
        scopedSlots: true,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择状态",
          option: () => this.common.findSysCodeType("SYS_STATUS"),
        },
      },
      {
        title: "操作",
        align: "center",
        width: 230,
        dataIndex: "options",
        hideInSearch: true,
        scopedSlots: true,
      },
    ];
    return {
      form: {
        paging: {
          page: 1,
          limit: 20,
          sort: [
            {
              property: "createTime",
              direction: "DESC",
            },
          ],
        },
      },
      list: [],
      pageTotal: 0,
      loading: false,
      columns,
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    // 获取数据
    getList() {
      this.loading = true;
      SettingSchool.schoolFindByPage(this.form).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
          this.pageTotal = res.total;
        }
        this.loading = false;
      });
    },
    // 翻页回调
    pagesChange(data) {
      this.form.paging.page = data.current;
      this.form.paging.limit = data.pageSize;
      this.getList();
    },
    // 搜索回调
    searchBack(data) {
      data.paging = {
        page: 1,
        limit: this.form.paging.limit,
      };
      this.form = { ...this.form, ...data };
      this.getList();
    },
    // 删除
    deleteCustomer(id) {
      this.pubMsg.confirm("是否确定删除此数据？").then(() => {
        this.loading = true;
        SettingSchool.schoolBasicDelete({ ids: id }).then(res => {
          if (res.code == this.config.pubCode) {
            this.pubMsg.tipMessage("删除成功！", "success");
            this.getList();
          }
          this.loading = false;
        });
      });
    },
    dockList(data) {
      this.$refs.dockingListModal.open(data);
    },

    add(type, data) {
      this.$refs.addModalModal.open(type, data);
    },
    moduleOk(data) {
      if (data) {
        this.getList();
      }
    },
  },
};
</script>
